import { baseApi } from "./baseApi"
import type { AdminProfile, LoginRequest, LoginResponse } from "../../types/auth"

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginRequest>({
      query: (body) => ({ url: "/auth/login", method: "POST", body }),
    }),
    me: build.query<AdminProfile, void>({
      query: () => "/auth/me",
      providesTags: [{ type: "Auth", id: "ME" }],
    }),
    logoutSession: build.mutation<{ ok: true }, void>({
      queryFn: async () => ({ data: { ok: true } }),
      invalidatesTags: [{ type: "Auth", id: "ME" }],
    }),
    refreshToken: build.mutation<{ backendImplemented: false; message: string }, void>({
      queryFn: async () => ({
        data: {
          backendImplemented: false,
          message: "Refresh token endpoint is not implemented on backend yet.",
        },
      }),
    }),
    forgotPassword: build.mutation<{ backendImplemented: false; message: string }, { email: string }>({
      queryFn: async () => ({
        data: {
          backendImplemented: false,
          message: "Forgot password endpoint is not implemented on backend yet.",
        },
      }),
    }),
    resetPassword: build.mutation<
      { backendImplemented: false; message: string },
      { token: string; password: string }
    >({
      queryFn: async () => ({
        data: {
          backendImplemented: false,
          message: "Reset password endpoint is not implemented on backend yet.",
        },
      }),
    }),
    sessionPermissions: build.query<{ permissions: string[] }, void>({
      queryFn: async (_arg, api) => {
        const state = api.getState() as any
        return {
          data: {
            permissions: state.auth?.permissions || [],
          },
        }
      },
      providesTags: [{ type: "Auth", id: "PERMISSIONS" }],
    }),
  }),
})

export const {
  useLoginMutation,
  useLazyMeQuery,
  useMeQuery,
  useLogoutSessionMutation,
  useRefreshTokenMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useSessionPermissionsQuery,
} = authApi
